<template>
    <div>
        <vs-popup
                title="Kleding koppelen"
                :active.sync="showPopup"
                v-if="deliverer !== null"
        >
            <div class="vx-row">
                <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input
                            class="w-full"
                            label="Kledingstuk"
                            v-model="clothing.name"
                    />
                </div>
                <vs-button class="mr-3 mb-2" @click="saveClothing()">Opslaan</vs-button>
            </div>
        </vs-popup>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                showPopup: false,
                deliverer: null,
                clothing: {
                    name: "",
                }
            };
        },
        methods: {
            saveClothing() {
                let data = {
                    _method: 'POST',
                    name: this.clothing.name,
                    deliverer_id: this.deliverer.id,
                };
                this.$http
                    .post("/v1/deliverer/clothes/create", data, {
                        headers: {
                            Authorization:
                                "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                        },
                    })
                    .then(() => {
                        this.$util.notify('Gelukt', 'Kleding is toegevoegd', this.$vs)
                        this.$events.fire('open-deliverer-modal', this.deliverer);
                        this.showPopup = false;
                    })
                    .catch((error) => {
                        console.log(error);
                        this.$util.logError(error, this.$vs);
                    });
            }
        },
        mounted() {
            this.isMounted = true;
            this.$events.listen('open-clothing-model', (deliverer) => {
                this.showPopup = true;
                this.deliverer = deliverer;
                console.log(this.deliverer);
            });
        },
    };
</script>